export const PAGE_SIZE = 10;
export const ASC = 'ASC';
export const DESC = 'DESC';
